import {
  FootfallCountInfoRequest,
  FootfallCountInfoResponse,
  VenueCountRequest,
  VenueCountResponse,
} from 'src/common-services/types/geo-types'
import { BaseClient } from 'src/common-services/clients/base-client'

export class GeoClient extends BaseClient {
  getVenueCounts(request: VenueCountRequest): Promise<VenueCountResponse> {
    throw new Error('not implemented')
  }

  getFootfallCounts(request: FootfallCountInfoRequest): Promise<FootfallCountInfoResponse> {
    throw new Error('not implemented')
  }
}
